import { useEffect } from "react";
import Header from "../components/Header";
import Nosotros from "../components/Nosotros";
import Footer from "../components/Footer";
import FloatingWhatsApp from "../components/FloatingWhatsApp";
import { ArrowLeft, MessageCircle } from "lucide-react";

const WA_LINK =
    "https://wa.me/543704504444?text=" +
    encodeURIComponent("Hola RAMSOL, quisiera consultar por un proyecto.");

export default function NosotrosPage() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-[#0A0A0A] text-white min-h-screen" data-testid="nosotros-page">
            <Header />
            <main className="pt-24 md:pt-28">
                {/* Page intro */}
                <section className="border-b border-[#1a1a1a]">
                    <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16">
                        <a
                            href="/"
                            className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-white/55 hover:text-[#14888F] transition-colors"
                            data-testid="back-home-link"
                        >
                            <ArrowLeft size={14} />
                            Volver al inicio
                        </a>
                        <p className="mt-8 text-[10px] uppercase tracking-[0.25em] text-[#14888F] font-bold">
                            Nuestra historia
                        </p>
                        <h1
                            className="mt-3 text-4xl md:text-6xl lg:text-7xl font-black uppercase tracking-tight leading-[0.95]"
                            style={{ fontFamily: "Chivo" }}
                            data-testid="nosotros-page-title"
                        >
                            Conocé a <span className="text-[#14888F]">RAMSOL</span>.
                        </h1>
                    </div>
                </section>

                {/* Reused detail section */}
                <Nosotros />

                {/* CTA bottom */}
                <section className="border-t border-[#1a1a1a] bg-[#0E0E0E]" data-testid="nosotros-cta">
                    <div className="max-w-5xl mx-auto px-6 md:px-12 py-20 md:py-24 text-center">
                        <p className="overline">¿Listo para tu próxima obra?</p>
                        <h2
                            className="mt-5 text-3xl md:text-5xl font-black uppercase tracking-tight leading-[0.95]"
                            style={{ fontFamily: "Chivo" }}
                        >
                            Construyamos juntos.
                        </h2>
                        <p className="mt-5 text-white/65 max-w-xl mx-auto">
                            Contanos los detalles del proyecto y te respondemos con una propuesta técnica clara.
                        </p>
                        <div className="mt-10 flex flex-wrap justify-center gap-4">
                            <a href={WA_LINK} target="_blank" rel="noreferrer" className="btn-primary" data-testid="nosotros-wa-cta">
                                <MessageCircle size={16} />
                                Hablar por WhatsApp
                            </a>
                            <a href="/#contacto" className="btn-ghost" data-testid="nosotros-contact-cta">
                                Ir al formulario
                            </a>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
            <FloatingWhatsApp />
        </div>
    );
}
